import { TextField } from "@mui/material";
import FormControl from "@mui/material/FormControl";
import InputBase from "@mui/material/InputBase";
import { styled } from "@mui/material/styles";
import * as React from "react";

const BootstrapInput = styled(InputBase)(({ theme }) => ({
	"label + &": {
		marginTop: theme.spacing(3),
	},
	"& .MuiInputBase-input": {
		borderRadius: 4,
		position: "relative",
		backgroundColor: theme.palette.background.paper,
		border: "1px solid #ced4da",
		fontSize: 16,
		padding: "10px 26px 10px 12px",
		transition: theme.transitions.create(["border-color", "box-shadow"]),
		// Use the system font instead of the default Roboto font.
		fontFamily: [
			"-apple-system",
			"BlinkMacSystemFont",
			'"Segoe UI"',
			"Roboto",
			'"Helvetica Neue"',
			"Arial",
			"sans-serif",
			'"Apple Color Emoji"',
			'"Segoe UI Emoji"',
			'"Segoe UI Symbol"',
		].join(","),
		"&:focus": {
			borderRadius: 4,
			borderColor: "#80bdff",
			boxShadow: "0 0 0 0.2rem rgba(0,123,255,.25)",
		},
	},
}));

const DropdownInput = (props) => {
	let { label, onChange, value, classname, options, ...others } = props;
	return (
		<FormControl fullWidth>
			<TextField
				select
				label={label}
				SelectProps={{
					native: true,
				}}
				inputProps={{
					style: {
						padding: 5,
						alignItems: "center",
						textTransform: "inherit",
					},
				}}
				size="small"
				variant="outlined"
				value={value}
				onChange={onChange}
				sx={{ minWidth: "4em", fontSize: 10 }}
			>
				<option></option>
				{options !== undefined && options.length > 0
					? options.map((opt, index) => (
							<option value={opt} key={index} sx={{ fontSize: 10 }}>
								{opt}
							</option>
					  ))
					: null}
			</TextField>
		</FormControl>
	);
};
export default DropdownInput;
